import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { Inspection } from '../../shared/models/index';
import { PluginComponent } from '../plugin.component';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './inspectionInfo.component.html',
    standalone: false
})
export class InspectionInfoPluginComponent extends BasePlugin implements OnInit {
  public plugin: any;
  public inspection: Inspection;
  public typeInspectionValue: string;

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'plugins',
      this.plugin.id,
      'inspectionInfo',
      'edit'
    ];
  }

  isEmptyObject(obj) {
    return obj && Object.keys(obj).length === 0;
  }
}

PluginComponent.plugins['inspectioninfo'] = InspectionInfoPluginComponent;
